import React from "react";
const styles = {
  container: {
    // height: "30px",
  },
  input: {
    width: "55px",
    height: "auto",
    padding: "0 5px",

    // height: "30px",
  },
  button: {
    height: "100%",
    padding: "0 10px",
  },
};
const ItemQuantitySelector = ({
  quantity,
  setQuantity,
  deleteItem,
  isOrderConfirmed,
  isKotCompleted,
}) => {
  const incrementQuantity = () => {
    setQuantity(quantity + 1, 1);
  };

  const decrementQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1, -1);
    } else {
      deleteItem();
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    // console.log("change", value);
    if (value.length > 4) {
      alert("Maximum quantity thresold reached");
    } else if (value === "") {
      setQuantity(1);
    } else if (typeof parseInt(value) === "number") {
      setQuantity(e.target.value);
    } else {
    }
  };
  return (
    <div className="form-group mb-0 orderquantitybtns ">
      <div className="input-group" style={styles.container}>
        {!isOrderConfirmed && (
          <span className="input-group-prepend ">
            <button
              style={styles.button}
              type="button"
              className="btn btn-outline-light shadow-none"
              onClick={decrementQuantity}
              disabled={isOrderConfirmed}
            >
              <i className="mdi mdi-minus "></i>
            </button>
          </span>
        )}
        <input
          style={styles.input}
          type="text"
          id="example-input3-group2"
          name="example-input3-group2"
          className="form-control"
          value={quantity}
          disabled={isOrderConfirmed || isKotCompleted}
          onChange={(e) => {
            handleChange(e);
          }}
        />
        {!isOrderConfirmed && !isKotCompleted && (
          <span className="input-group-append">
            <button
              style={styles.button}
              type="button"
              className="btn btn-outline-light shadow-none"
              onClick={incrementQuantity}
              disabled={isOrderConfirmed}
            >
              <i className="mdi mdi-plus"></i>
            </button>
          </span>
        )}
      </div>
    </div>
  );
};

export default ItemQuantitySelector;
